import { Theme, themedValue } from '../__styling'
import { EmailPreferenceSection } from './components/PreferenceSection'

export const thewestContent: EmailPreferenceSection[] = [
    {
        sectionTitle: 'Newsletters',
        sectionItems: [
            {
                id: 'wan_newsletter-west-news',
                name: 'News Headlines',
                description: 'Daily news headlines from our newsroom',
                frequency: 'Daily',
                subAccount: 'wan_newsletters',
                guid: 'f935486e-d64a-4949-9519-687b170e978a',
                unSubId: 15560,
            },
            {
                id: 'wan_newsletter-west-sport',
                name: 'Sports News',
                description: 'The latest in Sport from The West Australian',
                frequency: 'Twice Daily',
                subAccount: 'wan_newsletters',
                guid: 'f935486e-d64a-4949-9519-687b170e978a',
                unSubId: 15112,
            },
            {
                id: 'wan_newsletter-west-business',
                name: 'Business News',
                description: 'The latest in Business from The West Australian',
                frequency: 'Daily',
                subAccount: 'wan_newsletters',
                guid: 'f935486e-d64a-4949-9519-687b170e978a',
                unSubId: 15559,
            },
            {
                id: 'wan_newsletter-west-tomorrows-front-page',
                name: `Tomorrow's Front Page`,
                description: 'Daily preview of tomorrow’s newspaper',
                frequency: 'Daily',
                subAccount: 'wan_newsletters',
                guid: 'e13d2836-8285-4ba3-a676-331dfdae13bc',
                unSubId: 15866,
            },
            {
                id: 'wan_newsletter-west-bulls-n-bears',
                name: `Bulls N' Bears | Public Companies`,
                description: `The latest news on public companies`,
                frequency: 'Weekly',
                subAccount: 'wan_newsletters',
                guid: '388ca061-a385-4a40-97be-50ae2e3859ff',
                unSubId: 15979,
            },
            {
                id: 'wan_travelclub-enews',
                name: `West Travel Club`,
                description:
                    'eTravel Newsletter with travel stores from experts',
                frequency: 'Weekly',
                subAccount: 'wan_travelclub',
                guid: '499e6f2e-176c-4468-8623-24a91ea42012',
                unSubId: 161727,
            },
        ],
    },
    {
        sectionTitle: 'Subscriber Exclusive Newsletters',
        sectionItems: [
            {
                id: undefined,
                name: 'West Rewards',
                description: 'Subscriber competitions, discounts and giveaways',
                frequency: undefined,
                subAccount: 'wan_promotions',
                guid: undefined,
                unSubId: 14583,
            },
            {
                id: undefined,
                name: 'Exclusive Content',
                description: 'Special series and features as they drop',
                frequency: undefined,
                subAccount: 'wan_promotions',
                guid: undefined,
                unSubId: 16232,
            },
            {
                id: undefined,
                name: 'Note from the Editor',
                description: 'Hear from our Editor in Chief, Anthony De Ceglie',
                frequency: undefined,
                subAccount: 'wan_promotions',
                guid: 'd1088bef-aec0-46c8-ad11-14f3f2085d48',
                unSubId: 15692,
            },
        ],
    },
]

export const perthnowContent: EmailPreferenceSection[] = [
    {
        sectionTitle: 'Newsletters',
        sectionItems: [
            {
                id: undefined,
                name: 'News Briefing',
                description: 'Daily news headlines from our newsroom',
                frequency: 'Daily',
                subAccount: 'wan_newsletters',
                guid: '2f9ca2c1-d268-45c2-b521-f16e17354bc5',
                unSubId: 15108,
            },
            {
                id: undefined,
                name: 'Local',
                description: "Daily preview of tomorrow's newspaper",
                frequency: 'Twice Weekly',
                subAccount: 'wan_newsletters',
                guid: '20ea7fef-5759-45b2-80d1-6da25813c1f7',
                unSubId: 16984,
            },
            {
                id: undefined,
                name: 'Weekly Paper',
                description: 'Weekly news roundup from our newsroom',
                frequency: 'Weekly',
                subAccount: 'wan_newsletters',
                guid: '20ea7fef-5759-45b2-80d1-6da25813c1f7',
                unSubId: 18378,
            },
        ],
    },
    {
        sectionTitle: 'Marketing & Promotions',
        sectionItems: [
            {
                id: undefined,
                name: 'Competitions',
                description: 'Regular oppurtunities to win great prizes',
                frequency: 'Daily',
                subAccount: 'wan_promotions',
                guid: undefined,
                unSubId: 16005,
            },
            {
                id: undefined,
                name: 'Partner Promotions',
                description: 'Receive exclusive offers from our partners',
                frequency: undefined,
                subAccount: 'wan_promotions',
                guid: undefined,
                unSubId: 161729,
            },
            {
                id: undefined,
                name: 'Surveys',
                description: 'Provide meaningful feedback to help us improve',
                frequency: undefined,
                subAccount: 'wan_subscriptionservice',
                guid: undefined,
                unSubId: 16897,
            },
        ],
    },
]

const preferenceOptions = {
    thewest: [thewestContent, perthnowContent],
    perthnow: [perthnowContent, thewestContent],
    fallback: [],
}

export function getMastheadPreferences(
    theme: Theme,
): EmailPreferenceSection[][] {
    return themedValue<
        EmailPreferenceSection[][],
        EmailPreferenceSection[][],
        EmailPreferenceSection[][]
    >(theme, preferenceOptions)
}
